import { useState, useEffect } from 'react'

/**
 * Hook para persistir estado en localStorage
 * @param key - Clave única para el localStorage (se namespaced automáticamente si se proporciona namespace)
 * @param defaultValue - Valor por defecto si no hay nada guardado
 * @param namespace - Opcional: namespace para aislar datos por caso/usuario
 */
export function usePersistedState<T>(
  key: string,
  defaultValue: T,
  namespace?: string
): [T, (value: T) => void] {
  const storageKey = namespace ? `progress_filters_${namespace}_${key}` : `progress_filters_${key}`

  const [state, setState] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(storageKey)
      return item ? JSON.parse(item) : defaultValue
    } catch (error) {
      console.error(`Error reading localStorage key "${storageKey}":`, error)
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(state))
    } catch (error) {
      console.error(`Error saving to localStorage key "${storageKey}":`, error)
    }
  }, [storageKey, state])

  return [state, setState]
}

